import { Tooltip } from "@mui/material";

// tagType can be "file" or "chunk"
// tagValue is the value of the tag
const getTagExplanation = (tagScore, tagType, tagValues) => {
  // if this is a header row or don't have any tag values, go super general
  if (tagValues.length === 0) {
    if (tagScore >= 0.9 && tagScore <= 1.0) {
      return `For this tag, the system is highly confident information found with clear context and formatting`;
    } else if (tagScore >= 0.7 && tagScore < 0.9) {
      return `For this tag, information found but with slight ambiguity in context or formatting`;
    } else if (tagScore >= 0.5 && tagScore < 0.7) {
      return `For this tag, partial information found or information with significant ambiguity`;
    } else if (tagScore < 0.5) {
      return `For this tag, information found is incomplete or highly ambiguous`;
    }
  }
  const lowercaseTagValues = tagValues.map((value) => value.toLowerCase());
  if (
    tagValues.length === 1 &&
    (lowercaseTagValues[0] === "not found" || lowercaseTagValues[0] === "no")
  ) {
    if (tagScore >= 0.9 && tagScore <= 1.0) {
      return `Information is not present in this ${tagType} after thorough examination`;
    } else if (tagScore >= 0.7 && tagScore < 0.9) {
      return `Information may be present in this ${tagType} but evidence is unclear`;
    } else if (tagScore >= 0.0 && tagScore < 0.7) {
      return `Uncertain whether this information is missing. Double check the ${tagType} to ensure it's not present.`;
    }
  } else {
    if (tagScore >= 0.9 && tagScore <= 1.0) {
      return `Information found with clear context and formatting`;
    } else if (tagScore > 0.7 && tagScore < 0.9) {
      return `Information found but with slight ambiguity in context or formatting`;
    } else if (tagScore >= 0.5 && tagScore <= 0.7) {
      return `Partial information found or information with significant ambiguity`;
    } else if (tagScore < 0.5) {
      return `Information found is incomplete or highly ambiguous`;
    }
  }
};

export const TagScore = ({ tagScore, tagValues = [], tagType = "file" }) => {
  if (!tagScore) return null;
  return (
    <div className="flex items-center mt-1">
      <Tooltip title={getTagExplanation(tagScore, tagType, tagValues)}>
        <div className="text-xs flex items-center">
          <span
            className={`px-1.5 py-0.5 rounded-md font-medium ${
              tagScore >= 0.9
                ? "bg-green-100 text-green-800"
                : tagScore >= 0.8
                  ? "bg-blue-100 text-blue-800"
                  : "bg-amber-100 text-amber-800"
            }`}
          >
            {tagScore.toFixed(2)}
          </span>
        </div>
      </Tooltip>
    </div>
  );
};
